module.exports = __webpack_public_path__ + "static/cbn-logo-8553c4dcb3162b5b8d89b0972c2986a1.jpg";